import React, { useEffect, useState, useRef } from 'react';
import './Formulario.css';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';
import PopupNovaPessoa from '../components/PopupNovaPessoa';
import PopupHorasReais from '../components/PopupHorasReais';

// Função utilitária para chamadas da API com fallback
const apiCall = async (endpoint, method = 'GET', data = null) => {
  const urls = [
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`
  ];

  for (const url of urls) {
    try {
      console.log(`Tentando ${method} em: ${url}`);
      const config = {
        method,
        headers: {
          'Content-Type': 'application/json',
        }
      };
      const token = getAuthToken();
      if (token) config.headers['Authorization'] = 'Bearer ' + token;
      
      if (data && (method === 'POST' || method === 'PUT')) {
        config.body = JSON.stringify(data);
      }

      const response = await fetch(url, config);
      
      if (response.ok) {
        console.log(`✅ Sucesso em: ${url}`);
        if (method === 'DELETE' || response.status === 204) {
          return { success: true };
        }
        return await response.json();
      }
      console.log(`❌ Falha em: ${url} - Status: ${response.status}`);
    } catch (error) {
      console.log(`❌ Erro em: ${url} - ${error.message}`);
    }
  }
  
  throw new Error(`Nenhuma URL da API funcionou para ${method} ${endpoint}. Verifique se o backend está rodando.`);
};

function FormularioAgendamento({ 
  idAgendamento, 
  idCliente, 
  idOportunidade, 
  clienteSelecionado,
  dataPreSelecionada,
  dataFixa = false,
  isEdicao = false, 
  mostrarBotaoVoltar = false,
  onClose, 
  onVoltar 
}) {
  // Determinar se é edição baseado na presença do idAgendamento
  const isEdicaoMode = isEdicao || !!idAgendamento;
  const [form, setForm] = useState({
    id: '',
    dataHora: '',
    dataFimAgenda: '',
    data: dataPreSelecionada || '',
    horaInicio: '',
    horaFim: '',
    clienteId: idCliente || (clienteSelecionado ? (clienteSelecionado.id || clienteSelecionado.Id) : ''),
    oportunidadeId: idOportunidade || '',
    entregaId: '',
    montagemId: '',
    garantiaId: '',
    manutencaoId: '',
    tipoAgendamentoId: '',
    titulo: '',
    descricao: '',
    observacoes: '',
    custo: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    cep: '',
    pessoasId: '',
    status: 'Agendado',
    dataCriacao: new Date().toISOString().split('T')[0],
    dataAtualizacao: '',
    ativo: true
  });

  const [horariosOcupados, setHorariosOcupados] = useState([]);
  const [horariosAgendamentoAtual, setHorariosAgendamentoAtual] = useState([]);
  const [carregandoHorarios, setCarregandoHorarios] = useState(false);
  const [horariosSelecionados, setHorariosSelecionados] = useState({
    inicio: null,
    fim: null
  });
  const [tiposAgendamento, setTiposAgendamento] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [oportunidades, setOportunidades] = useState([]);
  const [entregas, setEntregas] = useState([]);
  const [montagens, setMontagens] = useState([]);
  const [garantias, setGarantias] = useState([]);
  const [manutencoes, setManutencoes] = useState([]);
  const [responsaveis, setResponsaveis] = useState([]);
  // Responsáveis do agendamento (vários; com mais de um, um é o principal — é ele que aparece no card)
  // { chave, id (registro já salvo) | null, pessoasId, horasPrevistas, horasReais, principal }
  const novaLinhaResponsavel = () => ({ chave: `n${Date.now()}${Math.random()}`, id: null, pessoasId: '', horasPrevistas: '', horasReais: '', principal: false });
  const [responsaveisAgendamento, setResponsaveisAgendamento] = useState(() => [novaLinhaResponsavel()]);
  // Status gravado (para saber se o agendamento está sendo concluído agora)
  const [statusOriginal, setStatusOriginal] = useState('');
  // Concluir: pop-up das horas reais dos responsáveis ({ chaveDaLinha: horas } depois de confirmar)
  const [popupHorasAberto, setPopupHorasAberto] = useState(false);
  const horasReaisConclusaoRef = useRef(null);
  // "Adicionar nova pessoa": cadastra sem sair da tela e já coloca a pessoa numa linha de responsável
  const [novaPessoaAberta, setNovaPessoaAberta] = useState(false);
  const aoCriarPessoa = async (criada) => {
    await carregarResponsaveis();
    const id = criada?.id ?? criada?.Id;
    if (!id) return;
    setResponsaveisAgendamento(prev => {
      const vazia = prev.findIndex(r => !r.pessoasId);
      if (vazia >= 0) return prev.map((r, i) => (i === vazia ? { ...r, pessoasId: String(id) } : r));
      return [...prev, { ...novaLinhaResponsavel(), pessoasId: String(id) }];
    });
  };
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mostrarSucesso, setMostrarSucesso] = useState(false);
  const [botaoDesabilitado, setBotaoDesabilitado] = useState(false);
  const [popupConfirmacao, setPopupConfirmacao] = useState({ aberto: false, horario: null });
  const [popupTipoSelecao, setPopupTipoSelecao] = useState({ aberto: false, tipo: '', nome: '' });
  const [itensTipoSelecao, setItensTipoSelecao] = useState([]);
  const [itensTipoFiltrados, setItensTipoFiltrados] = useState([]);
  const [filtroTipoSelecao, setFiltroTipoSelecao] = useState('');
  const [carregandoItensTipo, setCarregandoItensTipo] = useState(false);
  const [popupEntregas, setPopupEntregas] = useState(false);
  const [entregasFiltradas, setEntregasFiltradas] = useState([]);
  const [filtroEntrega, setFiltroEntrega] = useState('');
  const [campoErro, setCampoErro] = useState(''); // campo com erro de validação (apenas o primeiro)

  // Lista de status disponíveis
  const statusDisponiveis = [
    'Agendado',
    'Confirmado', 
    'Em Andamento',
    'Concluído',
    'Cancelado',
    'Reagendado'
  ];

  // Expandir horários de 00:00 até 23:30 (meia em meia hora)
  const horariosDisponiveis = [];
  for (let hora = 0; hora < 24; hora++) {
    for (let minuto = 0; minuto < 60; minuto += 30) {
      const horaStr = hora.toString().padStart(2, '0');
      const minutoStr = minuto.toString().padStart(2, '0');
      horariosDisponiveis.push(`${horaStr}:${minutoStr}`);
    }
  }

  // Função para converter dataHora em data e hora separadas
  const separarDataHora = (dataHora) => {
    if (!dataHora) return { data: '', hora: '' };
    
    let datePart, timePart;
    
    if (dataHora.includes('T')) {
      [datePart, timePart] = dataHora.split('T');
    } else if (dataHora.includes(' ')) {
      [datePart, timePart] = dataHora.split(' ');
    } else {
      return { data: dataHora, hora: '' };
    }
    
    if (!timePart) return { data: datePart || '', hora: '' };
    
    const horaMinuto = timePart.substring(0, 5);
    return { data: datePart || '', hora: horaMinuto || '' };
  };

  // Função para combinar data e hora em dataHora
  const combinarDataHora = (data, hora) => {
    if (!data || !hora) return '';
    return `${data} ${hora}`;
  };

  // Função para verificar se um horário está entre início e fim
  const horarioEstaEntre = (horario, inicio, fim) => {
    if (!inicio || !fim) return false;
    const [horaH, horaM] = horario.split(':').map(Number);
    const [inicioH, inicioM] = inicio.split(':').map(Number);
    const [fimH, fimM] = fim.split(':').map(Number);
    
    const horarioMin = horaH * 60 + horaM;
    const inicioMin = inicioH * 60 + inicioM;
    const fimMin = fimH * 60 + fimM;
    
    return horarioMin >= inicioMin && horarioMin <= fimMin;
  };

  // Função para verificar se há horários ocupados entre início e fim
  const temHorarioOcupadoEntre = (inicio, fim) => {
    return horariosOcupados.some(ocupado => horarioEstaEntre(ocupado, inicio, fim));
  };

  // Função para selecionar horário (início/fim)
  const selecionarHorario = (horario) => {
    // Limpa erro de horário ao interagir
    if (campoErro === 'horarioInicio' || campoErro === 'horarioFim') setCampoErro('');
    // Verificar se o horário está ocupado por OUTRO agendamento
    if (horariosOcupados.includes(horario)) {
      // Abrir popup de confirmação
      setPopupConfirmacao({ aberto: true, horario });
      return;
    }
    
    // Se clicou no horário de início já selecionado, limpa toda a seleção
    if (horariosSelecionados.inicio === horario) {
      setHorariosSelecionados({ inicio: null, fim: null });
      setForm(prev => ({ 
        ...prev, 
        horaInicio: '', 
        horaFim: '', 
        dataHora: '',
        dataFimAgenda: ''
      }));
      return;
    }
    
    // Se clicou no horário de fim já selecionado, limpa toda a seleção
    if (horariosSelecionados.fim === horario) {
      setHorariosSelecionados({ inicio: null, fim: null });
      setForm(prev => ({ 
        ...prev, 
        horaInicio: '', 
        horaFim: '', 
        dataHora: '',
        dataFimAgenda: ''
      }));
      return;
    }
    
    // Processar seleção normal
    processarSelecaoHorario(horario);
  };

  // Função auxiliar para processar a seleção de horário
  const processarSelecaoHorario = (horario) => {
    if (!horariosSelecionados.inicio) {
      // Primeira seleção = horário de início
      setHorariosSelecionados({ inicio: horario, fim: null });
      setForm(prev => ({ ...prev, horaInicio: horario }));
    } else if (!horariosSelecionados.fim) {
      // Segunda seleção = pode ser fim ou novo início
      const inicio = horariosSelecionados.inicio;
      
      const [inicioH, inicioM] = inicio.split(':').map(Number);
      const [fimH, fimM] = horario.split(':').map(Number);
      const inicioMin = inicioH * 60 + inicioM;
      const fimMin = fimH * 60 + fimM;
      
      if (fimMin <= inicioMin) {
        // Se horário for anterior ou igual ao início, troca o início
        setHorariosSelecionados({ inicio: horario, fim: null });
        setForm(prev => ({ ...prev, horaInicio: horario, horaFim: '', dataFimAgenda: '' }));
        return;
      }
      
      setHorariosSelecionados(prev => ({ ...prev, fim: horario }));
      setForm(prev => ({ 
        ...prev, 
        horaFim: horario,
        dataHora: combinarDataHora(prev.data, inicio),
        dataFimAgenda: combinarDataHora(prev.data, horario)
      }));
    } else {
      // Já tem início e fim, reinicia seleção
      setHorariosSelecionados({ inicio: horario, fim: null });
      setForm(prev => ({ ...prev, horaInicio: horario, horaFim: '', dataFimAgenda: '' }));
    }
  };

  // Confirmar seleção de horário ocupado
  const confirmarHorarioOcupado = () => {
    const horario = popupConfirmacao.horario;
    setPopupConfirmacao({ aberto: false, horario: null });
    processarSelecaoHorario(horario);
  };

  // Cancelar seleção de horário ocupado
  const cancelarHorarioOcupado = () => {
    setPopupConfirmacao({ aberto: false, horario: null });
  };

  // Função para verificar se horário deve aparecer como ocupado/selecionado
  const getStatusHorario = (horario) => {
    // Se é o horário de início selecionado (laranja) - prioridade sobre ocupado
    if (horariosSelecionados.inicio === horario) return 'inicio';
    
    // Se é o horário de fim selecionado (laranja) - prioridade sobre ocupado
    if (horariosSelecionados.fim === horario) return 'fim';
    
    // Se está entre início e fim selecionado (laranja) - prioridade sobre ocupado
    if (horariosSelecionados.inicio && horariosSelecionados.fim && 
        horarioEstaEntre(horario, horariosSelecionados.inicio, horariosSelecionados.fim)) {
      return 'reservado';
    }
    
    // Se é o agendamento atual em edição (verde)
    if (horariosAgendamentoAtual.includes(horario)) return 'agendamento-atual';
    
    // Se é outro agendamento ocupado (vermelho)
    if (horariosOcupados.includes(horario)) return 'ocupado';
    
    return 'disponivel';
  };

  // Função para buscar agendamentos de uma data específica
  const buscarAgendamentosPorData = async (data) => {
    if (!data) {
      setHorariosOcupados([]);
      setHorariosAgendamentoAtual([]);
      return;
    }

    setCarregandoHorarios(true);
    
    try {
      const agendamentos = await apiCall('Agendamentos');
      
      const horariosOcupadosData = [];
      const horariosAtualData = [];
      
      agendamentos
        .filter(agendamento => {
          const { data: dataAgendamento } = separarDataHora(agendamento.dataHora);
          return dataAgendamento === data;
        })
        .forEach(agendamento => {
          const agendamentoId = agendamento.id || agendamento.Id;
          const ehAgendamentoAtual = idAgendamento && agendamentoId === idAgendamento;
          
          const { hora: horaInicio } = separarDataHora(agendamento.dataHora);
          const { hora: horaFim } = separarDataHora(agendamento.dataFimAgenda);
          
          if (!horaInicio) return;
          
          // Array de destino: atual (verde) ou ocupado (vermelho)
          const arrayDestino = ehAgendamentoAtual ? horariosAtualData : horariosOcupadosData;
          
          // Se não tem horário fim, apenas adiciona o horário de início
          if (!horaFim) {
            arrayDestino.push(horaInicio);
            return;
          }
          
          // Calcular todos os horários entre início e fim (incluindo ambos)
          const [horaI, minI] = horaInicio.split(':').map(Number);
          const [horaF, minF] = horaFim.split(':').map(Number);
          
          const inicioMin = horaI * 60 + minI;
          const fimMin = horaF * 60 + minF;
          
          // Gerar todos os horários ocupados no intervalo
          for (let min = inicioMin; min <= fimMin; min += 30) {
            const h = Math.floor(min / 60);
            const m = min % 60;
            const horarioFormatado = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
            arrayDestino.push(horarioFormatado);
          }
        });
      
      setHorariosOcupados(horariosOcupadosData);
      setHorariosAgendamentoAtual(horariosAtualData);
    } catch (error) {
      console.error('Erro ao buscar agendamentos:', error);
      setHorariosOcupados([]);
      setHorariosAgendamentoAtual([]);
    } finally {
      setCarregandoHorarios(false);
    }
  };

  // Carregar tipos de agendamento
  const carregarTiposAgendamento = async () => {
    try {
      console.log('🔄 Iniciando carregamento dos tipos de agendamento...');
      const tipos = await apiCall('TipoAgendamento');
      console.log('✅ Tipos de agendamento carregados com sucesso:', tipos);
      
      if (tipos && Array.isArray(tipos) && tipos.length > 0) {
        setTiposAgendamento(tipos.filter(t => !/montagem/i.test(t.nome || t.Nome || '')));
        console.log('📝 State atualizado com tipos:', tipos);
      } else {
        console.log('⚠️ Nenhum tipo retornado, usando fallback');
        setTiposAgendamento([
          { id: 1, nome: 'Oportunidade' },
          { id: 2, nome: 'Entrega' },
          { id: 4, nome: 'Garantia' },
          { id: 5, nome: 'Manutenção' }
        ]);
      }
    } catch (error) {
      console.error('❌ Erro ao carregar tipos de agendamento:', error);
      console.log('🔧 Usando tipos de fallback...');
      // Fallback: adicionar pelo menos o tipo Oportunidade
      setTiposAgendamento([
        { id: 1, nome: 'Oportunidade' },
        { id: 2, nome: 'Entrega' },
        { id: 4, nome: 'Garantia' },
        { id: 5, nome: 'Manutenção' }
      ]);
    }
  };

  // Carregar clientes
  const carregarClientes = async () => {
    try {
      const clientesData = await apiCall('Cliente');
      setClientes(clientesData || []);
    } catch (error) {
      console.error('Erro ao carregar clientes:', error);
      setClientes([]);
    }
  };

  // Carregar oportunidades
  const carregarOportunidades = async () => {
    try {
      const oportunidadesData = await apiCall('Oportunidade');
      setOportunidades(oportunidadesData || []);
    } catch (error) {
      console.error('Erro ao carregar oportunidades:', error);
      setOportunidades([]);
    }
  };

  // Carregar pessoas (substitui responsáveis) - lista completa de Pessoas
  const carregarResponsaveis = async () => {
    try {
      const pessoasData = await apiCall('Pessoas');
      const pessoasArray = Array.isArray(pessoasData) ? pessoasData : [];
      console.log('Pessoas carregadas:', pessoasArray.length);
      setResponsaveis(pessoasArray);
    } catch (error) {
      console.error('Erro ao carregar pessoas (Pessoas):', error);
      setResponsaveis([]);
    }
  };

  // Carregar dados se for edição
  useEffect(() => {
    if (idAgendamento) {
      const carregarAgendamento = async () => {
        try {
          console.log(`Carregando dados do agendamento ID: ${idAgendamento}`);
          const data = await apiCall(`Agendamentos/${idAgendamento}`);
          console.log('✅ Dados recebidos do backend:', data);
          
          const { data: dataInicio, hora: horaInicio } = separarDataHora(data.DataHora || data.dataHora);
          const { hora: horaFim } = separarDataHora(data.DataFimAgenda || data.dataFimAgenda || '');
          
          setForm({
            id: data.Id || data.id || '',
            dataHora: data.DataHora || data.dataHora || '',
            dataFimAgenda: data.DataFimAgenda || data.dataFimAgenda || '',
            data: dataInicio,
            horaInicio: horaInicio,
            horaFim: horaFim,
            clienteId: data.Id_cliente || data.id_cliente || data.clienteId || '',
            id_cliente: data.Id_cliente || data.id_cliente || data.clienteId || '',
            oportunidadeId: data.OportunidadeId || data.oportunidadeId || '',
            entregaId: data.EntregaId || data.entregaId || '',
            montagemId: data.MontagemId || data.montagemId || '',
            garantiaId: data.GarantiaId || data.garantiaId || '',
            manutencaoId: data.ManutencaoId || data.manutencaoId || '',
            tipoAgendamentoId: data.TipoAgendamentoId || data.tipoAgendamentoId || '',
            titulo: data.Titulo || data.titulo || '',
            descricao: data.Descricao || data.descricao || '',
            observacoes: data.Observacoes || data.observacoes || '',
            custo: data.Custo || data.custo || '',
            logradouro: data.Logradouro || data.logradouro || '',
            numero: data.Numero || data.numero || '',
            complemento: data.Complemento || data.complemento || '',
            bairro: data.Bairro || data.bairro || '',
            cidade: data.Cidade || data.cidade || '',
            estado: data.Estado || data.estado || '',
            cep: data.CEP || data.cep || '',
            pessoasId: data.PessoasId || data.pessoasId || data.PessoaId || data.pessoaId || data.ResponsavelId || data.responsavelId || '',
            status: data.Status || data.status || '',
            dataCriacao: data.DataCriacao || data.dataCriacao || '',
            dataAtualizacao: data.DataAtualizacao || data.dataAtualizacao || '',
            ativo: data.Ativo !== undefined ? data.Ativo : (data.ativo !== undefined ? data.ativo : true)
          });
          
          setStatusOriginal(data.Status || data.status || '');
          horasReaisConclusaoRef.current = null;
          // Responsáveis do agendamento
          try {
            const lista = await apiCall(`Agendamentos/${idAgendamento}/responsaveis`);
            const carregados = (Array.isArray(lista) ? lista : []).map(r => ({
              chave: `r${r.id ?? r.Id}`,
              id: r.id ?? r.Id,
              pessoasId: String(r.pessoasId ?? r.PessoasId ?? ''),
              horasPrevistas: r.horasPrevistas ?? r.HorasPrevistas ?? '',
              horasReais: r.horasReais ?? r.HorasReais ?? '',
              principal: !!(r.responsavelPrincipal ?? r.ResponsavelPrincipal)
            }));
            setResponsaveisAgendamento(carregados.length > 0 ? carregados : [novaLinhaResponsavel()]);
          } catch (e) {
            console.error('Erro ao carregar responsáveis do agendamento:', e);
            setResponsaveisAgendamento([novaLinhaResponsavel()]);
          }

          // NÃO setar horariosSelecionados ao carregar para edição
          // Os horários do agendamento devem aparecer em VERDE (agendamento-atual)
          // Laranja só quando o usuário clicar para selecionar novos horários
          
          console.log('✅ Dados do agendamento carregados para edição:', data);
        } catch (error) {
          console.error('❌ Erro ao carregar agendamento para edição:', error);
          setError(`Erro ao carregar agendamento: ${error.message}`);
        }
      };
      
      carregarAgendamento();
    } else {
      setForm(f => ({
        ...f,
        oportunidadeId: idOportunidade || '',
        id_cliente: idCliente || ''
      }));
    }
  }, [idAgendamento, idCliente, idOportunidade]);

  // Buscar tipos de agendamento e responsáveis ao carregar o componente
  useEffect(() => {
    console.log('Carregando tipos de agendamento e responsáveis...');
    carregarTiposAgendamento();
    carregarResponsaveis();
  }, []);

  // Log para debug dos tipos carregados
  useEffect(() => {
    console.log('Estado dos tipos de agendamento:', tiposAgendamento);
  }, [tiposAgendamento]);

  // Buscar horários ocupados quando a data mudar
  useEffect(() => {
    if (form.data) {
      buscarAgendamentosPorData(form.data);
    }
  }, [form.data]);

  // Pré-selecionar cliente quando clienteSelecionado for fornecido
  useEffect(() => {
    if (clienteSelecionado && !isEdicaoMode) {
      const clienteId = clienteSelecionado.id || clienteSelecionado.Id;
      console.log('Cliente selecionado do calendário:', clienteId, clienteSelecionado.nome || clienteSelecionado.Nome);
      
      setForm(prevForm => ({
        ...prevForm,
        clienteId: clienteId,
        id_cliente: clienteId
      }));
    }
  }, [clienteSelecionado, isEdicaoMode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Verificar se o botão está desabilitado
    if (botaoDesabilitado) {
      return;
    }
    
    setLoading(true);
    setError('');
    
    // Validações
    setCampoErro('');

    if (!form.data) {
      setError('Por favor, selecione uma data.');
      setCampoErro('data');
      setLoading(false);
      return;
    }
    
    if (!form.dataHora && !horariosSelecionados.inicio) {
      setError('Por favor, selecione um horário de início.');
      setCampoErro('horarioInicio');
      setLoading(false);
      return;
    }
    
    if (!form.dataFimAgenda && !horariosSelecionados.fim) {
      setError('Por favor, selecione um horário de fim.');
      setCampoErro('horarioFim');
      setLoading(false);
      return;
    }

    if (!form.tipoAgendamentoId) {
      setError('Por favor, selecione um tipo de agendamento.');
      setCampoErro('tipoAgendamentoId');
      setLoading(false);
      return;
    }

    // Validar se o ID correspondente ao tipo foi informado
    const tipoId = parseInt(form.tipoAgendamentoId);
    const nomesTipos = { 1: 'oportunidade', 2: 'entrega', 3: 'montagem', 4: 'garantia', 5: 'manutenção' };
    const camposTipos = { 1: 'oportunidadeId', 2: 'entregaId', 3: 'montagemId', 4: 'garantiaId', 5: 'manutencaoId' };
    if (nomesTipos[tipoId] && !form[camposTipos[tipoId]]) {
      setError(`Por favor, selecione uma ${nomesTipos[tipoId]} para este agendamento.`);
      setCampoErro('tipoAgendamentoId');
      setLoading(false);
      return;
    }
    
    // Responsáveis: obrigatório pelo menos um, sem repetir pessoa
    const responsaveisValidos = responsaveisAgendamento.filter(r => r.pessoasId);
    if (responsaveisValidos.length === 0) {
      setError('Por favor, escolha pelo menos um responsável.');
      setCampoErro('responsaveis');
      setLoading(false);
      document.getElementById('agend-form-responsaveis')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const pessoasEscolhidas = responsaveisValidos.map(r => String(r.pessoasId));
    if (new Set(pessoasEscolhidas).size !== pessoasEscolhidas.length) {
      setError('A mesma pessoa foi escolhida mais de uma vez como responsável.');
      setCampoErro('responsaveis');
      setLoading(false);
      return;
    }
    // Principal: opcional com vários responsáveis, mas no máximo um (com um só, ele é o principal)
    if (responsaveisValidos.filter(r => r.principal).length > 1) {
      setError('Só pode haver um responsável principal.');
      setCampoErro('responsaveis');
      setLoading(false);
      document.getElementById('agend-form-responsaveis')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const responsavelPrincipal = responsaveisValidos.length === 1 ? responsaveisValidos[0] : responsaveisValidos.find(r => r.principal);
    const horas = (v) => (v === '' || v === null || v === undefined ? null : parseFloat(v));

    // Concluindo o agendamento: as horas reais de cada responsável são informadas agora (no pop-up)
    const concluindo = idAgendamento && /conclu/i.test(form.status || '') && !/conclu/i.test(statusOriginal || '');
    if (concluindo && horasReaisConclusaoRef.current === null) {
      setLoading(false);
      setPopupHorasAberto(true);
      return;
    }

    // Preparar payload com todos os campos do modelo do backend
    const agendamentoPayload = {
      DataHora: form.dataHora,
      DataFimAgenda: form.dataFimAgenda,
      Id_cliente: form.clienteId || form.id_cliente || null,
      TipoAgendamentoId: form.tipoAgendamentoId ? parseInt(form.tipoAgendamentoId) : null,
      // Pessoa do agendamento = responsável principal (o servidor também acerta ao salvar os responsáveis)
      PessoasId: responsavelPrincipal ? parseInt(responsavelPrincipal.pessoasId) : null,
      Status: form.status || 'Agendado',
      Titulo: form.titulo || null,
      Descricao: form.descricao || null,
      Observacoes: form.observacoes || null,
      Custo: form.custo !== '' && form.custo !== null ? parseFloat(form.custo) : null,
      Logradouro: form.logradouro || null,
      Numero: form.numero || null,
      Complemento: form.complemento || null,
      Bairro: form.bairro || null,
      Cidade: form.cidade || null,
      Estado: form.estado || null,
      CEP: form.cep || null,
      DataCriacao: form.dataCriacao || new Date().toISOString().split('T')[0]
    };

    // Para edição, incluir o ID
    if (idAgendamento) {
      agendamentoPayload.Id = parseInt(idAgendamento);
    }

    // Adicionar o campo específico baseado no tipo de agendamento
    const tipoSelecionado = parseInt(form.tipoAgendamentoId);
    switch (tipoSelecionado) {
      case 1: // Oportunidade
        agendamentoPayload.OportunidadeId = form.oportunidadeId ? parseInt(form.oportunidadeId) : null;
        break;
      case 2: // Entrega
        agendamentoPayload.EntregaId = form.entregaId ? parseInt(form.entregaId) : null;
        break;
      case 3: // Montagem
        agendamentoPayload.MontagemId = form.montagemId ? parseInt(form.montagemId) : null;
        break;
      case 4: // Garantia
        agendamentoPayload.GarantiaId = form.garantiaId ? parseInt(form.garantiaId) : null;
        break;
      case 5: // Manutencao
        agendamentoPayload.ManutencaoId = form.manutencaoId ? parseInt(form.manutencaoId) : null;
        break;
    }

    try {
      let resultado;
      
      console.log('=== DEBUG AGENDAMENTO PAYLOAD ===');
      console.log('Form original:', form);
      console.log('Payload que será enviado:', agendamentoPayload);
      console.log('Modo:', idAgendamento ? 'Edição (PUT)' : 'Criação (POST)');
      console.log('TipoAgendamentoId:', form.tipoAgendamentoId);
      console.log('OportunidadeId:', form.oportunidadeId);
      console.log('================================');
      
      if (idAgendamento) {
        // Modo edição: PUT
        resultado = await apiCall(`Agendamentos/${idAgendamento}`, 'PUT', agendamentoPayload);
      } else {
        // Modo criação: POST
        console.log('Fazendo POST para: Agendamentos');
        resultado = await apiCall('Agendamentos', 'POST', agendamentoPayload);
      }
      
      console.log('✅ Agendamento salvo com sucesso:', resultado);

      // Responsáveis do agendamento (lista completa). Horas previstas só valem na criação.
      const agendamentoId = idAgendamento || resultado?.id || resultado?.Id;
      if (agendamentoId) {
        const resposta = await fetch(`${BASE_URL}/Agendamentos/${agendamentoId}/responsaveis`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getAuthToken()}` },
          body: JSON.stringify({
            criacao: !idAgendamento,
            responsaveis: responsaveisValidos.map(r => ({
              id: r.id || null,
              pessoasId: parseInt(r.pessoasId),
              horasPrevistas: horas(r.horasPrevistas),
              // Horas reais: só as informadas no fechamento; senão ficam como estão
              horasReais: horasReaisConclusaoRef.current && horasReaisConclusaoRef.current[r.chave] !== undefined ? horasReaisConclusaoRef.current[r.chave] : horas(r.horasReais),
              principal: responsaveisValidos.length === 1 || !!r.principal
            }))
          })
        });
        if (!resposta.ok) {
          const corpo = await resposta.json().catch(() => null);
          throw new Error(`o agendamento foi salvo, mas os responsáveis não: ${corpo?.mensagem || resposta.status}`);
        }
      }

      // ✅ SUCESSO - Para criar novo agendamento
      if (!idAgendamento) {
        console.log('✅ Agendamento criado com sucesso!');
        
        // Mostrar notificação de sucesso
        setMostrarSucesso(true);
        
        // Fechar popup após 2 segundos
        setTimeout(() => {
          setMostrarSucesso(false);
          if (onClose) onClose();
        }, 2000);
      } else {
        // Para edição, apenas fechar
        console.log('✅ Agendamento editado com sucesso!');
        if (onClose) onClose();
      }
      
    } catch (error) {
      console.error('❌ Erro ao salvar agendamento:', error);
      setError(`Erro ao salvar agendamento: ${error.message}`);
      alert(`Erro ao salvar agendamento: ${error.message}`);
      
      // ❌ ERRO - Desabilitar botão por 5 segundos
      setBotaoDesabilitado(true);
      setTimeout(() => {
        setBotaoDesabilitado(false);
      }, 5000);
    } finally {
      setLoading(false);
    }
  };

  // Função para obter nome do tipo de agendamento pelo ID
  const getNomeTipoAgendamento = (tipoId) => {
    const tipo = tiposAgendamento.find(t => (t.id || t.Id) === parseInt(tipoId));
    return tipo ? (tipo.nome || tipo.Nome) : 'Tipo não encontrado';
  };

  // Função para atualizar campos do form
  const buscarCep = async (cep) => {
    const cepLimpo = cep.replace(/\D/g, '');
    if (cepLimpo.length !== 8) return;
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await res.json();
      if (data.erro) return;
      setForm(prev => ({
        ...prev,
        logradouro: data.logradouro || prev.logradouro,
        bairro: data.bairro || prev.bairro,
        cidade: data.localidade || prev.cidade,
        estado: data.uf || prev.estado
      }));
    } catch {}
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'cep') {
      // Aplica máscara 00000-000
      const numeros = value.replace(/\D/g, '').slice(0, 8);
      const masked = numeros.length > 5 ? `${numeros.slice(0, 5)}-${numeros.slice(5)}` : numeros;
      setForm(prev => ({ ...prev, cep: masked }));
      if (numeros.length === 8) buscarCep(numeros);
      return;
    }
    setForm(prev => ({ ...prev, [name]: value }));
  };

  // Carregar itens para popup de seleção baseado no tipo
  const carregarItensPorTipo = async (tipoId, nomeTipo) => {
    setCarregandoItensTipo(true);
    try {
      const clienteId = form.clienteId || form.id_cliente;
      let endpoint = '';
      let nomePopup = '';

      switch (parseInt(tipoId)) {
        case 1: // Oportunidade
          endpoint = 'Oportunidade';
          nomePopup = 'Oportunidade';
          break;
        case 2: // Entrega
          endpoint = 'Entrega';
          nomePopup = 'Entrega';
          break;
        case 3: // Montagem
          endpoint = 'Montagem';
          nomePopup = 'Montagem';
          break;
        case 4: // Garantia
          endpoint = 'Garantia';
          nomePopup = 'Garantia';
          break;
        case 5: // Manutenção
          endpoint = 'Manutencao';
          nomePopup = 'Manutenção';
          break;
        default:
          return;
      }

      console.log(`🔄 Carregando ${nomePopup} para cliente ${clienteId}...`);
      const data = await apiCall(endpoint);
      let itensArray = Array.isArray(data) ? data : [];

      // Filtrar por cliente se temos clienteId
      if (clienteId) {
        const cId = parseInt(clienteId);
        itensArray = itensArray.filter(item => {
          const itemClienteId = item.clienteId || item.ClienteId || item.Id_cliente || item.id_cliente;
          return itemClienteId === cId;
        });
      }

      console.log(`✅ ${nomePopup} carregadas:`, itensArray.length);
      setItensTipoSelecao(itensArray);
      setItensTipoFiltrados(itensArray);
      setPopupTipoSelecao({ aberto: true, tipo: tipoId, nome: nomePopup });
    } catch (error) {
      console.error(`❌ Erro ao carregar itens do tipo:`, error);
      setItensTipoSelecao([]);
      setItensTipoFiltrados([]);
      setPopupTipoSelecao({ aberto: true, tipo: tipoId, nome: nomeTipo || 'Item' });
    } finally {
      setCarregandoItensTipo(false);
    }
  };

  // Filtrar itens do popup de tipo
  const aplicarFiltroTipoSelecao = (valor) => {
    setFiltroTipoSelecao(valor);
    if (!valor.trim()) {
      setItensTipoFiltrados(itensTipoSelecao);
      return;
    }
    const valorLower = valor.toLowerCase();
    const filtrados = itensTipoSelecao.filter(item => {
      const id = (item.id || item.Id || '').toString();
      const desc = (item.descricao || item.Descricao || item.oportunidade_Titulo || item.Oportunidade_Titulo || item.titulo || item.Titulo || item.descricaoProblema || item.DescricaoProblema || '').toLowerCase();
      const status = (item.status || item.Status || item.statusEntrega || item.StatusEntrega || '').toLowerCase();
      return id.includes(valorLower) || desc.includes(valorLower) || status.includes(valorLower);
    });
    setItensTipoFiltrados(filtrados);
  };

  // Selecionar item do popup de tipo
  const selecionarItemTipo = (item) => {
    const itemId = item.id || item.Id;
    const tipoId = parseInt(popupTipoSelecao.tipo);

    // Confirma a mudança de tipo E define o item escolhido
    const novoForm = { 
      ...form,
      tipoAgendamentoId: tipoId,
      oportunidadeId: '', 
      entregaId: '', 
      montagemId: '', 
      garantiaId: '', 
      manutencaoId: '' 
    };

    switch (tipoId) {
      case 1: novoForm.oportunidadeId = itemId; break;
      case 2: novoForm.entregaId = itemId; break;
      case 3: novoForm.montagemId = itemId; break;
      case 4: novoForm.garantiaId = itemId; break;
      case 5: novoForm.manutencaoId = itemId; break;
    }

    setForm(novoForm);
    setPopupTipoSelecao({ aberto: false, tipo: '', nome: '' });
    setFiltroTipoSelecao('');
    console.log(`✅ ${popupTipoSelecao.nome} selecionada: ID ${itemId}`);
  };

  // Voltar do popup de tipo — NÃO altera nada, apenas fecha o popup
  const voltarDoPopupTipo = () => {
    setPopupTipoSelecao({ aberto: false, tipo: '', nome: '' });
    setFiltroTipoSelecao('');
  };

  // Obter label de descrição para cada tipo de item
  const getDescricaoItem = (item) => {
    return item.oportunidade_Titulo || item.Oportunidade_Titulo || 
           item.titulo || item.Titulo || 
           item.descricao || item.Descricao || 
           item.descricaoProblema || item.DescricaoProblema || 
           'Sem descrição';
  };

  // Obter status do item
  const getStatusItem = (item) => {
    return item.status || item.Status || 
           item.statusEntrega || item.StatusEntrega || 
           item.statusMontagemId || item.StatusMontagemId ||
           'N/D';
  };

  // Carregar entregas e abrir popup (legado - mantido para compatibilidade)
  const carregarEntregas = async () => {
    try {
      console.log('🔄 Carregando entregas...');
      const data = await apiCall('Entrega');
      const entregasArray = Array.isArray(data) ? data : [];
      console.log('✅ Entregas carregadas:', entregasArray.length);
      setEntregas(entregasArray);
      setEntregasFiltradas(entregasArray);
      setPopupEntregas(true);
    } catch (error) {
      console.error('❌ Erro ao carregar entregas:', error);
      setEntregas([]);
      setEntregasFiltradas([]);
      alert('Erro ao carregar entregas. Verifique a conexão com o servidor.');
    }
  };

  // Filtrar entregas
  const aplicarFiltroEntregas = (valor) => {
    setFiltroEntrega(valor);
    if (!valor.trim()) {
      setEntregasFiltradas(entregas);
      return;
    }
    
    const valorLower = valor.toLowerCase();
    const filtradas = entregas.filter(entrega => {
      const id = (entrega.id || entrega.Id || '').toString();
      const descricao = (entrega.descricao || entrega.Descricao || '').toLowerCase();
      const local = (entrega.localEntrega || entrega.LocalEntrega || '').toLowerCase();
      const status = (entrega.statusEntrega || entrega.StatusEntrega || '').toLowerCase();
      
      return id.includes(valorLower) || 
             descricao.includes(valorLower) || 
             local.includes(valorLower) ||
             status.includes(valorLower);
    });
    setEntregasFiltradas(filtradas);
  };

  // Selecionar entrega
  const selecionarEntrega = (entrega) => {
    const entregaId = entrega.id || entrega.Id;
    setForm(prev => ({ ...prev, entregaId: entregaId }));
    setPopupEntregas(false);
    setFiltroEntrega('');
    console.log('✅ Entrega selecionada:', entregaId);
  };

  return (
    <form
      id="agend-form-geral"
      onSubmit={handleSubmit}
      style={{
        backgroundColor: '#fff',
        padding: '30px',
        borderRadius: '10px',
        width: '100%',
        height: '100%',
        margin: '8px auto 40px auto', // Adicionado marginTop de 8px
        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
        fontFamily: 'Arial, sans-serif',
        position: 'relative'
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '20px'
        }}
      >
        {/* Campo Data */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label
            htmlFor="data"
            style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}
          >
            Data
          </label>
          <input
            id="data"
            type="date"
            name="data"
            value={form.data}
            readOnly={dataFixa}
            onChange={dataFixa ? undefined : e => {
              const novaData = e.target.value;
              setForm(prev => ({ 
                ...prev, 
                data: novaData,
                horaInicio: '', 
                horaFim: '',
                dataHora: '',
                dataFimAgenda: ''
              }));
              setHorariosSelecionados({ inicio: null, fim: null });
              if (campoErro === 'data') setCampoErro('');
            }}
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: campoErro === 'data' ? '2px solid red' : '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '85%',
              transition: 'border 0.2s ease',
              backgroundColor: dataFixa ? '#f5f5f5' : undefined,
              cursor: dataFixa ? 'not-allowed' : undefined
            }}
          />
        </div>

        {/* Campo ID Cliente */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            ID Cliente
          </label>
          <input
            type="number"
            name="id_cliente"
            value={form.id_cliente}
            readOnly
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '85%',
              backgroundColor: '#f5f5f5',
              cursor: 'not-allowed'
            }}
          />
        </div>

        {/* Campo Horários - Sistema início/fim */}
        <div id="agend-secao-horarios" style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px', color: (campoErro === 'horarioInicio' || campoErro === 'horarioFim') ? 'red' : undefined }}>
            Horários {carregandoHorarios && <span style={{color: '#666', fontSize: '12px'}}>(Carregando...)</span>}
            {campoErro === 'horarioInicio' && <span style={{ color: 'red', fontSize: '12px', marginLeft: 8 }}>Selecione o horário de início</span>}
            {campoErro === 'horarioFim' && <span style={{ color: 'red', fontSize: '12px', marginLeft: 8 }}>Selecione o horário de fim</span>}
          </label>
          
          {/* Legenda - apenas em modo de edição */}
          {idAgendamento && (
            <div style={{ 
              marginBottom: '10px', 
              display: 'flex', 
              gap: '20px', 
              fontSize: '12px',
              padding: '8px',
              backgroundColor: '#f9f9f9',
              borderRadius: '4px',
              border: '1px solid #e0e0e0'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ 
                  width: '12px', 
                  height: '12px', 
                  borderRadius: '50%', 
                  backgroundColor: '#4caf50',
                  display: 'inline-block'
                }} />
                <span style={{ color: '#4caf50', fontWeight: '600' }}>Agendamento atual</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ 
                  width: '12px', 
                  height: '12px', 
                  borderRadius: '50%', 
                  backgroundColor: '#ff4444',
                  display: 'inline-block'
                }} />
                <span style={{ color: '#ff4444', fontWeight: '600' }}>Ocupados por outros agendamentos</span>
              </div>
            </div>
          )}
          
          {/* Instruções */}
          <div style={{ marginBottom: '10px', fontSize: '12px', color: '#666' }}>
            {!horariosSelecionados.inicio && 'Clique para selecionar horário de INÍCIO'}
            {horariosSelecionados.inicio && !horariosSelecionados.fim && `Início: ${horariosSelecionados.inicio} - Clique para selecionar horário de FIM`}
            {horariosSelecionados.inicio && horariosSelecionados.fim && `Período: ${horariosSelecionados.inicio} às ${horariosSelecionados.fim} - Clique em outro horário para reiniciar`}
          </div>
          
          {/* Container dos botões de horário - ALTURA REDUZIDA */}
          <div style={{
            border: '1px solid #ccc',
            borderRadius: '5px',
            padding: '10px',
            backgroundColor: '#fff',
            maxHeight: '120px', // REDUZIDO: aproximadamente 3 linhas
            overflowY: 'auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)', // Mais colunas para economizar espaço
            gap: '4px',
            width: '95%'
          }}>
            {horariosDisponiveis.map(horario => {
              const status = getStatusHorario(horario);
              
              let backgroundColor, color, cursor, border;
              
              switch (status) {
                case 'agendamento-atual':
                  backgroundColor = '#4caf50'; // Verde
                  color = '#fff';
                  cursor = 'pointer';
                  border = '2px solid #4caf50';
                  break;
                case 'ocupado':
                  backgroundColor = '#ff4444'; // Vermelho
                  color = '#fff';
                  cursor = 'not-allowed';
                  border = '1px solid #ff4444';
                  break;
                case 'inicio':
                  backgroundColor = 'rgb(235, 133, 0)'; // Laranja
                  color = '#fff';
                  cursor = 'pointer';
                  border = '2px solid rgb(235, 133, 0)';
                  break;
                case 'fim':
                  backgroundColor = 'rgb(235, 133, 0)'; // Laranja
                  color = '#fff';
                  cursor = 'pointer';
                  border = '2px solid rgb(235, 133, 0)';
                  break;
                case 'reservado':
                  backgroundColor = 'rgb(235, 133, 0)'; // Laranja
                  color = '#fff';
                  cursor = 'pointer';
                  border = '1px solid rgb(235, 133, 0)';
                  break;
                default: // disponivel
                  backgroundColor = '#f8f9fa';
                  color = '#333';
                  cursor = 'pointer';
                  border = '1px solid #dee2e6';
              }
              
              return (
                <button
                  key={horario}
                  type="button"
                  disabled={carregandoHorarios}
                  onClick={() => selecionarHorario(horario)}
                  style={{
                    padding: '6px 2px',
                    fontSize: '11px',
                    fontWeight: status === 'inicio' || status === 'fim' ? 'bold' : 'normal',
                    backgroundColor,
                    color,
                    border,
                    borderRadius: '4px',
                    cursor,
                    transition: 'all 0.2s ease',
                    minHeight: '28px'
                  }}
                  title={
                    status === 'ocupado' ? 'Horário ocupado' :
                    status === 'inicio' ? 'Horário de início - Clique para desselecionar' :
                    status === 'fim' ? 'Horário de fim - Clique para desselecionar' :
                    status === 'reservado' ? 'Horário reservado para este agendamento' :
                    'Clique para selecionar'
                  }
                >
                  {horario}
                </button>
              );
            })}
          </div>
        </div>

        {/* Responsáveis do agendamento: vários; com mais de um, marca o principal (é o que aparece no card) */}
        <div
          id="agend-form-responsaveis"
          style={{
            gridColumn: '1 / -1',
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            padding: 12,
            borderRadius: 8,
            background: '#fafafa',
            border: campoErro === 'responsaveis' ? '2px solid red' : '1px solid #e0e0e0'
          }}
        >
          <label style={{ fontWeight: '500', fontSize: '14px' }}>Responsáveis *</label>
          <div style={{ fontSize: 12, color: '#666' }}>
            {'Informe as horas previstas de cada responsável. As horas reais são lançadas ao concluir o agendamento.'}
          </div>
          {responsaveisAgendamento.map((r) => {
            const alterar = (campo, valor) => {
              setResponsaveisAgendamento(prev => prev.map(x => (x.chave === r.chave ? { ...x, [campo]: valor } : x)));
              if (campoErro === 'responsaveis') setCampoErro('');
            };
            const campoHoras = { width: 110, padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '14px' };
            return (
              <div key={r.chave} style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                <select
                  value={r.pessoasId}
                  onChange={(e) => alterar('pessoasId', e.target.value)}
                  style={{ flex: '1 1 200px', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', fontSize: '14px' }}
                >
                  <option value="">Selecione uma pessoa...</option>
                  {responsaveis.map((resp) => (
                    <option
                      key={resp.id || resp.Id || resp.PessoasId || resp.pessoasId}
                      value={resp.id || resp.Id || resp.PessoasId || resp.pessoasId}
                    >
                      {resp.nome || resp.Nome || resp.NomeCompleto || resp.nomeCompleto}
                    </option>
                  ))}
                </select>
                {/* Horas previstas ao adicionar o responsável; as reais só no fechamento (status Concluído) */}
                {!r.id ? (
                  <input
                    type="number" min="0" step="0.5" placeholder="Hrs previstas" title="Horas previstas"
                    value={r.horasPrevistas} onChange={(e) => alterar('horasPrevistas', e.target.value)} style={campoHoras}
                  />
                ) : (
                  <span title="Previstas definidas ao adicionar; reais lançadas ao concluir" style={{ fontSize: 12, color: '#666' }}>
                    Previstas: <strong style={{ color: '#1565c0' }}>{(parseFloat(r.horasPrevistas) || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}h</strong>
                    {' · '}Reais: <strong style={{ color: '#d32f2f' }}>{(parseFloat(r.horasReais) || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}h</strong>
                  </span>
                )}
                {responsaveisAgendamento.filter(x => x.pessoasId).length > 1 && r.pessoasId && (
                  <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, fontWeight: 600, color: r.principal ? '#b26a00' : '#555', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={!!r.principal}
                      onChange={() => {
                        // Só um principal: marcar este desmarca os outros; clicar de novo desmarca
                        setResponsaveisAgendamento(prev => prev.map(x => ({ ...x, principal: x.chave === r.chave ? !r.principal : false })));
                        if (campoErro === 'responsaveis') setCampoErro('');
                      }}
                    />
                    Principal
                  </label>
                )}
                <button
                  type="button"
                  title="Remover este responsável"
                  onClick={() => setResponsaveisAgendamento(prev => {
                    const resto = prev.filter(x => x.chave !== r.chave);
                    return resto.length > 0 ? resto : [novaLinhaResponsavel()];
                  })}
                  style={{ padding: '6px 12px', backgroundColor: '#f44336', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 700 }}
                >
                  ×
                </button>
              </div>
            );
          })}
          <div>
            <button
              type="button"
              onClick={() => setResponsaveisAgendamento(prev => [...prev, novaLinhaResponsavel()])}
              style={{ padding: '8px 14px', backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}
            >
              + Adicionar responsável
            </button>
            <button
              type="button"
              onClick={() => setNovaPessoaAberta(true)}
              style={{ marginLeft: 8, padding: '8px 14px', backgroundColor: '#fff', color: 'rgb(235, 133, 0)', border: '1px solid rgb(235, 133, 0)', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}
            >
              Adicionar nova pessoa
            </button>
          </div>
        </div>

        {/* Campo Status */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            Status
          </label>
          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '85%'
            }}
          >
            <option value="">Selecione...</option>
            <option value="Agendado">Agendado</option>
            <option value="Confirmado">Confirmado</option>
            <option value="Em Andamento">Em Andamento</option>
            <option value="Concluído">Concluído</option>
            <option value="Cancelado">Cancelado</option>
          </select>
        </div>

        {/* Campo Tipo Agendamento */}
        <div id="agend-secao-tipo" style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            Tipo de Agendamento
          </label>
          {isEdicaoMode ? (
            // Modo edição: campo não editável
            <input
              type="text"
              value={form.tipoAgendamentoId ? getNomeTipoAgendamento(form.tipoAgendamentoId) : ''}
              readOnly
              style={{
                padding: '8px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                outline: 'none',
                fontSize: '14px',
                width: '85%',
                backgroundColor: '#f5f5f5',
                cursor: 'not-allowed'
              }}
            />
          ) : (
            // Modo criação: campo editável
            <select
              name="tipoAgendamentoId"
              value={form.tipoAgendamentoId}
              onChange={(e) => {
                const tipoId = e.target.value;
                if (!tipoId) {
                  setForm(prev => ({ ...prev, tipoAgendamentoId: '', oportunidadeId: '', entregaId: '', montagemId: '', garantiaId: '', manutencaoId: '' }));
                  return;
                }
                if (campoErro === 'tipoAgendamentoId') setCampoErro('');
                // Não muda o tipo ainda — abre o popup para confirmar a escolha
                const tipoSelecionado = tiposAgendamento.find(t => (t.id || t.Id) === parseInt(tipoId));
                const nomeTipo = tipoSelecionado ? (tipoSelecionado.nome || tipoSelecionado.Nome) : '';
                carregarItensPorTipo(tipoId, nomeTipo);
              }}
              style={{
                padding: '8px',
                borderRadius: '5px',
                border: campoErro === 'tipoAgendamentoId' ? '2px solid red' : '1px solid #ccc',
                outline: 'none',
                fontSize: '14px',
                width: '85%'
              }}
            >
              <option value="">Selecione o tipo...</option>
              {tiposAgendamento.map((tipo) => (
                <option 
                  key={tipo.id || tipo.Id} 
                  value={tipo.id || tipo.Id}
                >
                  {tipo.nome || tipo.Nome}
                </option>
              ))}
              {/* Fallback caso não carregue do backend */}
              {tiposAgendamento.length === 0 && (
                <option value="1">Oportunidade</option>
              )}
            </select>
          )}

          {/* Item selecionado abaixo do tipo */}
          {!isEdicaoMode && form.tipoAgendamentoId && (() => {
            const tipoId = parseInt(form.tipoAgendamentoId);
            const mapa = {
              1: { campo: 'oportunidadeId', nome: 'Oportunidade' },
              2: { campo: 'entregaId', nome: 'Entrega' },
              3: { campo: 'montagemId', nome: 'Montagem' },
              4: { campo: 'garantiaId', nome: 'Garantia' },
              5: { campo: 'manutencaoId', nome: 'Manutenção' }
            };
            const info = mapa[tipoId];
            if (!info || !form[info.campo]) return null;
            return (
              <span style={{ marginTop: '6px', fontSize: '13px', color: '#555', fontWeight: '600' }}>
                {info.nome} #{form[info.campo]}
              </span>
            );
          })()}
        </div>

        {/* Campo Título */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            Título
          </label>
          <input
            type="text"
            name="titulo"
            value={form.titulo}
            onChange={handleChange}
            placeholder="Título do agendamento"
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '85%'
            }}
          />
        </div>

        {/* Campo Descrição */}
        <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            Descrição
          </label>
          <textarea
            name="descricao"
            value={form.descricao}
            onChange={handleChange}
            placeholder="Descrição detalhada do agendamento"
            rows="3"
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '95%',
              resize: 'vertical'
            }}
          />
        </div>

        {/* Campo Custo */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            Custo (R$)
          </label>
          <input
            type="number"
            name="custo"
            value={form.custo}
            onChange={handleChange}
            placeholder="R$ 0,00"
            step="0.01"
            min="0"
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '85%'
            }}
          />
        </div>

        {/* Campo Observações */}
        <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
          <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>
            Observações
          </label>
          <textarea
            name="observacoes"
            value={form.observacoes}
            onChange={handleChange}
            placeholder="Observações adicionais sobre o agendamento"
            rows="3"
            style={{
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '95%',
              resize: 'vertical'
            }}
          />
        </div>
      </div>

      {/* ─── Seção Endereço ─── */}
      <div style={{ marginTop: '24px' }}>
        <div style={{
          fontSize: '15px',
          fontWeight: '700',
          color: 'rgb(235, 133, 0)',
          borderBottom: '2px solid rgb(235, 133, 0)',
          paddingBottom: '6px',
          marginBottom: '16px'
        }}>Endereço</div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '16px'
        }}>
          {/* CEP */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>CEP</label>
            <input type="text" name="cep" value={form.cep} onChange={handleChange}
              placeholder="00000-000"
              maxLength={9}
              style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', fontSize: '14px', width: '85%' }}
            />
          </div>
          {/* Logradouro */}
          <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
            <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>Logradouro</label>
            <input type="text" name="logradouro" value={form.logradouro} onChange={handleChange}
              placeholder="Rua, Avenida, etc."
              style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', fontSize: '14px', width: '97%' }}
            />
          </div>
          {/* Número */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>Número</label>
            <input type="text" name="numero" value={form.numero} onChange={handleChange}
              placeholder="Ex: 123"
              style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', fontSize: '14px', width: '85%' }}
            />
          </div>
          {/* Complemento */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>Complemento</label>
            <input type="text" name="complemento" value={form.complemento} onChange={handleChange}
              placeholder="Apto, Sala, etc."
              style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', fontSize: '14px', width: '85%' }}
            />
          </div>
          {/* Bairro */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>Bairro</label>
            <input type="text" name="bairro" value={form.bairro} onChange={handleChange}
              placeholder="Bairro"
              style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', fontSize: '14px', width: '85%' }}
            />
          </div>
          {/* Cidade */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>Cidade</label>
            <input type="text" name="cidade" value={form.cidade} onChange={handleChange}
              placeholder="Cidade"
              style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', fontSize: '14px', width: '85%' }}
            />
          </div>
          {/* Estado */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '5px', fontWeight: '500', fontSize: '14px' }}>Estado</label>
            <select name="estado" value={form.estado} onChange={handleChange}
              style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', outline: 'none', fontSize: '14px', width: '85%', backgroundColor: '#fff' }}
            >
              <option value="">Selecione...</option>
              {[['AC','Acre'],['AL','Alagoas'],['AP','Amapá'],['AM','Amazonas'],['BA','Bahia'],['CE','Ceará'],['DF','Distrito Federal'],['ES','Espírito Santo'],['GO','Goiás'],['MA','Maranhão'],['MT','Mato Grosso'],['MS','Mato Grosso do Sul'],['MG','Minas Gerais'],['PA','Pará'],['PB','Paraíba'],['PR','Paraná'],['PE','Pernambuco'],['PI','Piauí'],['RJ','Rio de Janeiro'],['RN','Rio Grande do Norte'],['RS','Rio Grande do Sul'],['RO','Rondônia'],['RR','Roraima'],['SC','Santa Catarina'],['SP','São Paulo'],['SE','Sergipe'],['TO','Tocantins']].map(([uf, nome]) => (
                <option key={uf} value={uf}>{uf} – {nome}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Exibir erros */}
      {error && (
        <div style={{ 
          marginTop: '20px', 
          padding: '10px', 
          backgroundColor: '#ffe6e6', 
          border: '1px solid #ff9999', 
          borderRadius: '5px',
          color: '#cc0000',
          fontSize: '14px'
        }}>
          {error}
        </div>
      )}

      <div className="form-buttons-container" style={{ marginTop: '30px', textAlign: 'center' }}>
        <button
          type="submit"
          disabled={loading || botaoDesabilitado}
          className="btn-salvar-agendamento"
          style={{
            backgroundColor: (loading || botaoDesabilitado) ? '#ccc' : 'rgb(235, 133, 0)',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '12px 24px',
            fontSize: '16px',
            cursor: (loading || botaoDesabilitado) ? 'not-allowed' : 'pointer',
            marginRight: '10px',
            transition: 'background-color 0.3s ease',
            opacity: botaoDesabilitado ? 0.7 : 1
          }}
          onMouseEnter={(e) => {
            if (!loading && !botaoDesabilitado) e.target.style.backgroundColor = 'rgb(250, 178, 65)';
          }}
          onMouseLeave={(e) => {
            if (!loading && !botaoDesabilitado) e.target.style.backgroundColor = 'rgb(235, 133, 0)';
          }}
        >
          {botaoDesabilitado ? 'Aguarde 5 segundos...' : (loading ? 'Salvando...' : (idAgendamento ? 'Atualizar' : 'Salvar'))} {!botaoDesabilitado && 'Agendamento'}
        </button>
        
        <button
          type="button"
          onClick={onClose}
          className="btn-cancelar-agendamento"
          style={{
            backgroundColor: '#666',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '12px 24px',
            fontSize: '16px',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#888'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#666'}
        >
          Cancelar
        </button>
      </div>
      
      {/* Notificação de sucesso */}
      {mostrarSucesso && (
        <div style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'white',
          color: 'rgb(235, 133, 0)',
          padding: '15px 30px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          fontSize: '16px',
          fontWeight: '600',
          zIndex: 9999,
          animation: 'fadeInOut 2.5s ease-in-out forwards',
          border: '2px solid rgb(235, 133, 0)'
        }}>
          Agendamento adicionado com sucesso!
        </div>
      )}

      {/* Popup genérico de seleção por tipo de agendamento */}
      {popupTipoSelecao.aberto && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10001
          }}
        >
          <div 
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '25px',
              maxWidth: '900px',
              width: '90%',
              maxHeight: '85vh',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Cabeçalho */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '20px',
              paddingBottom: '15px',
              borderBottom: '2px solid rgb(235, 133, 0)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <button
                  onClick={() => { voltarDoPopupTipo(); }}
                  style={{
                    background: 'none',
                    border: '2px solid rgb(235, 133, 0)',
                    borderRadius: '6px',
                    color: 'rgb(235, 133, 0)',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    padding: '4px 12px',
                    lineHeight: 1
                  }}
                  title="Voltar"
                >
                  ←
                </button>
                <h3 style={{ 
                  margin: 0, 
                  color: 'rgb(235, 133, 0)',
                  fontSize: '22px',
                  fontWeight: '700'
                }}>
                  Selecionar {popupTipoSelecao.nome}
                </h3>
              </div>
            </div>

            {/* Filtro */}
            <div style={{ marginBottom: '20px' }}>
              <input
                type="text"
                placeholder={`Filtrar por ID, descrição ou status...`}
                value={filtroTipoSelecao}
                onChange={(e) => aplicarFiltroTipoSelecao(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  borderRadius: '8px',
                  border: '2px solid #e0e0e0',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'border 0.2s ease',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => e.target.style.borderColor = 'rgb(235, 133, 0)'}
                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
              />
            </div>

            {/* Lista de itens */}
            <div style={{
              flex: 1,
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              {carregandoItensTipo ? (
                <div style={{ textAlign: 'center', padding: '40px 20px', color: '#666', fontSize: '16px' }}>
                  Carregando...
                </div>
              ) : itensTipoFiltrados.length === 0 ? (
                <div style={{
                  textAlign: 'center',
                  padding: '40px 20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '16px'
                }}>
                  <div style={{ color: '#999', fontSize: '16px' }}>
                    {filtroTipoSelecao 
                      ? `Nenhum(a) ${popupTipoSelecao.nome.toLowerCase()} encontrado(a) com este filtro.` 
                      : `Não há nenhum(a) ${popupTipoSelecao.nome.toLowerCase()} para este cliente.`}
                  </div>
                  <button
                    onClick={voltarDoPopupTipo}
                    style={{
                      padding: '12px 28px',
                      backgroundColor: 'rgb(235, 133, 0)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '15px',
                      fontWeight: '600',
                      cursor: 'pointer'
                    }}
                  >
                    Voltar
                  </button>
                </div>
              ) : (
                itensTipoFiltrados.map(item => (
                  <div
                    key={item.id || item.Id}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '15px 18px',
                      border: '2px solid #e0e0e0',
                      borderRadius: '8px',
                      backgroundColor: '#fafafa',
                      cursor: 'pointer'
                    }}
                    onClick={() => selecionarItemTipo(item)}
                  >
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div>
                          <span style={{ fontSize: '12px', color: '#999', fontWeight: '600', display: 'block', marginBottom: '4px' }}>ID</span>
                          <span style={{ fontSize: '16px', fontWeight: '700', color: '#333' }}>#{item.id || item.Id}</span>
                        </div>
                        <div style={{ flex: 1, minWidth: '200px' }}>
                          <span style={{ fontSize: '12px', color: '#999', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Descrição</span>
                          <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>{getDescricaoItem(item)}</span>
                        </div>
                        <div style={{ minWidth: '120px' }}>
                          <span style={{ fontSize: '12px', color: '#999', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Status</span>
                          <span style={{ 
                            fontSize: '13px', padding: '4px 10px', borderRadius: '12px', 
                            backgroundColor: '#e3f2fd', color: '#1976d2', fontWeight: '600', display: 'inline-block' 
                          }}>
                            {getStatusItem(item)}
                          </span>
                        </div>
                      </div>
                    </div>
                    <button
                      style={{
                        padding: '10px 20px',
                        backgroundColor: 'rgb(235, 133, 0)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        marginLeft: '15px',
                        whiteSpace: 'nowrap'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        selecionarItemTipo(item);
                      }}
                    >
                      Selecionar
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}

      {/* Popup de seleção de entregas */}
      {popupEntregas && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10001
          }}
          onClick={() => {
            setPopupEntregas(false);
            setFiltroEntrega('');
          }}
        >
          <div 
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '25px',
              maxWidth: '900px',
              width: '90%',
              maxHeight: '85vh',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Cabeçalho */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '20px',
              paddingBottom: '15px',
              borderBottom: '2px solid rgb(235, 133, 0)'
            }}>
              <h3 style={{ 
                margin: 0, 
                color: 'rgb(235, 133, 0)',
                fontSize: '22px',
                fontWeight: '700'
              }}>
                Selecionar Entrega
              </h3>
              <button
                onClick={() => {
                  setPopupEntregas(false);
                  setFiltroEntrega('');
                }}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: 'rgb(235, 133, 0)',
                  border: 'none',
                  color: 'white',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(235, 133, 0, 0.3)'
                }}
              >
                ×
              </button>
            </div>

            {/* Filtro */}
            <div style={{ marginBottom: '20px' }}>
              <input
                type="text"
                placeholder="Filtrar por ID, descrição, local ou status..."
                value={filtroEntrega}
                onChange={(e) => aplicarFiltroEntregas(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  borderRadius: '8px',
                  border: '2px solid #e0e0e0',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'border 0.2s ease',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => e.target.style.borderColor = 'rgb(235, 133, 0)'}
                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
              />
            </div>

            {/* Lista de entregas */}
            <div style={{
              flex: 1,
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              {entregasFiltradas.length === 0 ? (
                <div style={{
                  textAlign: 'center',
                  padding: '40px 20px',
                  color: '#999',
                  fontSize: '16px'
                }}>
                  {filtroEntrega ? 'Nenhuma entrega encontrada com este filtro.' : 'Nenhuma entrega disponível.'}
                </div>
              ) : (
                entregasFiltradas.map(entrega => (
                  <div
                    key={entrega.id || entrega.Id}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '15px 18px',
                      border: '2px solid #e0e0e0',
                      borderRadius: '8px',
                      backgroundColor: '#fafafa',
                      cursor: 'pointer'
                    }}
                    onClick={() => selecionarEntrega(entrega)}
                  >
                    <div style={{ flex: 1 }}>
                      <div style={{ 
                        display: 'flex', 
                        gap: '15px', 
                        alignItems: 'center',
                        flexWrap: 'wrap'
                      }}>
                        <div>
                          <span style={{ 
                            fontSize: '12px', 
                            color: '#999', 
                            fontWeight: '600',
                            display: 'block',
                            marginBottom: '4px'
                          }}>
                            ID
                          </span>
                          <span style={{ 
                            fontSize: '16px', 
                            fontWeight: '700',
                            color: '#333'
                          }}>
                            #{entrega.id || entrega.Id}
                          </span>
                        </div>
                        
                        <div style={{ flex: 1, minWidth: '200px' }}>
                          <span style={{ 
                            fontSize: '12px', 
                            color: '#999', 
                            fontWeight: '600',
                            display: 'block',
                            marginBottom: '4px'
                          }}>
                            Descrição
                          </span>
                          <span style={{ 
                            fontSize: '14px',
                            color: '#333',
                            fontWeight: '500'
                          }}>
                            {entrega.descricao || entrega.Descricao || 'Sem descrição'}
                          </span>
                        </div>

                        <div style={{ minWidth: '150px' }}>
                          <span style={{ 
                            fontSize: '12px', 
                            color: '#999', 
                            fontWeight: '600',
                            display: 'block',
                            marginBottom: '4px'
                          }}>
                            Local
                          </span>
                          <span style={{ 
                            fontSize: '14px',
                            color: '#555'
                          }}>
                            {entrega.localEntrega || entrega.LocalEntrega || 'N/D'}
                          </span>
                        </div>

                        <div style={{ minWidth: '120px' }}>
                          <span style={{ 
                            fontSize: '12px', 
                            color: '#999', 
                            fontWeight: '600',
                            display: 'block',
                            marginBottom: '4px'
                          }}>
                            Status
                          </span>
                          <span style={{ 
                            fontSize: '13px',
                            padding: '4px 10px',
                            borderRadius: '12px',
                            backgroundColor: '#e3f2fd',
                            color: '#1976d2',
                            fontWeight: '600',
                            display: 'inline-block'
                          }}>
                            {entrega.statusEntrega || entrega.StatusEntrega || 'Pendente'}
                          </span>
                        </div>
                      </div>
                    </div>

                    <button
                      style={{
                        padding: '10px 20px',
                        backgroundColor: 'rgb(235, 133, 0)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        marginLeft: '15px',
                        whiteSpace: 'nowrap'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        selecionarEntrega(entrega);
                      }}
                    >
                      Selecionar
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}

      {/* Popup de confirmação de horário ocupado */}
      {popupConfirmacao.aberto && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10000
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              cancelarHorarioOcupado();
            }
          }}
        >
          <div 
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '30px',
              maxWidth: '450px',
              width: '90%',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
              textAlign: 'center'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Ícone de aviso */}
            <div style={{ 
              fontSize: '48px', 
              marginBottom: '15px',
              color: 'rgb(235, 133, 0)'
            }}>
              ⚠️
            </div>

            {/* Título */}
            <h3 style={{ 
              margin: '0 0 15px 0', 
              color: '#333',
              fontSize: '20px',
              fontWeight: '700'
            }}>
              Horário Ocupado
            </h3>

            {/* Mensagem */}
            <p style={{ 
              margin: '0 0 25px 0', 
              color: '#666',
              fontSize: '15px',
              lineHeight: '1.5'
            }}>
              Já existe agendamento para o horário <strong>{popupConfirmacao.horario}</strong>.
              <br />
              Deseja prosseguir mesmo assim?
            </p>

            {/* Botões */}
            <div style={{ 
              display: 'flex', 
              gap: '12px', 
              justifyContent: 'center' 
            }}>
              <button
                onClick={confirmarHorarioOcupado}
                style={{
                  backgroundColor: 'rgb(235, 133, 0)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '12px 28px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 2px 6px rgba(235, 133, 0, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgb(208, 116, 0)';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 10px rgba(235, 133, 0, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgb(235, 133, 0)';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 6px rgba(235, 133, 0, 0.3)';
                }}
              >
                Sim, Prosseguir
              </button>

              <button
                onClick={cancelarHorarioOcupado}
                style={{
                  backgroundColor: '#fff',
                  color: '#666',
                  border: '2px solid #ddd',
                  borderRadius: '6px',
                  padding: '12px 28px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f5f5f5';
                  e.target.style.borderColor = '#999';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#fff';
                  e.target.style.borderColor = '#ddd';
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeInOut {
          0% {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
          15% {
            opacity: 1;
            transform: translateX(-50%) translateY(0px);
          }
          85% {
            opacity: 1;
            transform: translateX(-50%) translateY(0px);
          }
          100% {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
        }
      `}</style>
      {novaPessoaAberta && (
        <PopupNovaPessoa onFechar={() => setNovaPessoaAberta(false)} onCriada={aoCriarPessoa} />
      )}
      {popupHorasAberto && (
        <PopupHorasReais
          titulo="Concluir agendamento: horas reais dos responsáveis"
          responsaveis={responsaveisAgendamento.filter(r => r.pessoasId).map(r => {
            const pessoa = responsaveis.find(p => String(p.id || p.Id) === String(r.pessoasId));
            return { id: r.chave, nome: pessoa?.nome || pessoa?.Nome, horasPrevistas: r.horasPrevistas, horasReais: r.horasReais };
          })}
          onCancelar={() => setPopupHorasAberto(false)}
          onConfirmar={(horasPorLinha) => {
            horasReaisConclusaoRef.current = horasPorLinha;
            setPopupHorasAberto(false);
            setTimeout(() => handleSubmit({ preventDefault: () => {} }), 0);
          }}
        />
      )}
    </form>
  );
}

export default FormularioAgendamento;
